import { createTheme as createMuiTheme } from "@mui/material/styles";

import { componentsTheme } from "./components";
import { lightPalette } from "./palette";
import { shapeTheme } from "./shape";
import { typographyTheme } from "./typography";

/** The one admin theme (light only). Built once, not on every render. */
export const theme = createMuiTheme({
  palette: lightPalette,
  components: componentsTheme,
  typography: typographyTheme,
  shape: shapeTheme,
  breakpoints: { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } },
});

/** Kept for callers that still ask for a mode; there is only light. */
export const createTheme = (_mode?: string) => theme;
